import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

const Logo = ({
  className,
  ...props
}) => {

  const classes = classNames(
    'brand',
    className
  );

  return (
    <div
      {...props}
      className={classes}
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '10px'
    }}
    >
      <Link to="/" className="brand-logo" aria-label="Mindmap home">
        <img
          src={`${process.env.PUBLIC_URL || ''}/icon.svg`}
          alt="Mindmap"
          width={36}
          height={36} />
      </Link>
      <Link to="/">
        <h6 className="m-0" style={{letterSpacing: '0.18rem', color: '#171717', fontWeight: 700}}>MINDMAP</h6>
      </Link>
    </div>
  );
}

export default Logo;
